import {
	createRouter,
	createWebHashHistory,
	createWebHistory
} from 'vue-router'
import Home from '../views/Home.vue'
import Serve from '../views/Serve.vue'
import Solve from '../views/Solve.vue'
import Case from '../views/Case.vue'

const routes = [
	{
		path: '/shapp',
		name: 'Home',
		component: Home
	},
	{
		path: '/shapp/serve',
		name: 'Serve',
		component: Serve
	},
	{
		path: '/shapp/solve',
		name: 'Solve',
		component: Solve
	},
	{
		path: '/shapp/case',
		name: 'Case',
		component: Case
	},

	// {
	// 	path: '/',
	// 	name: 'Home',
	// 	component: Home
	// },
	// {
	// 	path: '/serve',
	// 	name: 'Serve',
	// 	component: Serve
	// },
	// {
	// 	path: '/solve',
	// 	name: 'Solve',
	// 	component: Solve
	// },
	// {
	// 	path: '/case',
	// 	name: 'Case',
	// 	component: Case
	// }
]

const router = createRouter({
	mode: 'history',
	base: '/dist/',
	history: createWebHistory(),
	routes
})

export default router